import { ShopRendererApiClient } from '@fourthwall/services/dist/ShopRendererApiClient'
import { createQueryHook } from '@fourthwall/utils/dist/queries'

export const useThemeChangelogQuery = createQueryHook(ShopRendererApiClient.getThemeChangelog, {
  queryKey: ['themeChangelog'],
})
